import { isStringNotEmpty } from './objectUtils';

export const getForwardedQueryString = (searchParams: URLSearchParams | string = ''): string => {
	const forwardedParams = new URLSearchParams(searchParams);
	// a lead id belongs to one funnel visit, so carried into another funnel it would resume the wrong
	// lead; the funnel's own goTo drops it for the same reason
	forwardedParams.delete('lid');
	return forwardedParams.toString();
};

export const appendQueryString = (url: string, queryString: string): string => (
	isStringNotEmpty(queryString) ? `${url}?${queryString}` : url
);
